export default __webpack_public_path__ + "static/media/3.a5d7ac42.png";